import React from "react";
import { useSelector, useDispatch } from "react-redux";
import { Button, Alert } from "antd";
import ticketActions from "../../../redux/ticket/actions";
import schedulesActions from "../../../redux/schedules/actions";
import {
  epochToNormalDate,
  dateStringToEpoch,
  convertToEuro,
} from "../../../utils/utility";
import { decryptData, encryptData } from "../../../utils/utility";
import arrow from "../../../images/right-arrow.png";
import { t } from "i18next";

const TicketCardTwoWay = ({ ticket, index }) => {
  const dispatch = useDispatch();
  const { addTicketsToCart, cancelTicketReservation } = ticketActions;
  const { getSchedules, getSchedulesTwoWay } = schedulesActions;
  const { cities } = useSelector((state) => state.citiesReducer);
  const { companies, token, companiesDetails, showEuroPrice } = useSelector(
    (state) => state.mainReducer
  );
  const { checkoutTickets } = useSelector((state) => state.ticketReducer);
  const {
    destinationFrom,
    destinationTo,
    destinationDate,
    destinationDateTwoWay,
  } = useSelector((state) => state.destinationReducer);
  const localStorageCart = decryptData(localStorage.getItem("cart")) || [];
  const localStorageReservedTickets =
    decryptData(localStorage.getItem("reservedTickets")) || [];

  const removeTicketFromCart = (kursId, placeNumber) => {
    const updatedCart = checkoutTickets.filter(
      (item) => !(item.kursId === kursId && item.placeNumber === placeNumber)
    );
    dispatch(addTicketsToCart(updatedCart));

    const updatedLocalStorageCart = localStorageCart.filter(
      (item) =>
        !(
          item.firstDirection &&
          item.firstDirection.kursId === kursId &&
          item.firstDirection.placeNumber === placeNumber
        )
    );
    localStorage.setItem("cart", encryptData(updatedLocalStorageCart));

    const event = new Event("cartUpdated");
    window.dispatchEvent(event);

    const updatedReservedTickets = localStorageReservedTickets.filter(
      (item) =>
        !(
          item.firstDirection &&
          item.firstDirection.kursId === kursId &&
          item.firstDirection.placeNumber === placeNumber
        )
    );
    localStorage.setItem(
      "reservedTickets",
      encryptData(updatedReservedTickets)
    );
  };

  const getTotalTicketsAmount = localStorageCart?.reduce(
    (accumulator, product) => {
      return accumulator + product.price;
    },
    0
  );

  const getCitiesNames = (cartTicketCityId) => {
    return cities.find((city) => city?.id === cartTicketCityId)?.name;
  };

  return (
    <div className="ticket-card" key={index}>
      <div className="ticket-item">
        <div className="ticket-item-header">
          <img
            src={`data:image/jpeg;base64,${companiesDetails?.logo}`}
            alt="ticketLogo"
            className="logo"
          />
          <div className="ticket-item-e-ticket-mark">
            <small>{t("twoWay")}</small>
          </div>
        </div>

        <section className="ticket-item-cities-container">
          <div className="ticket-item-city">
            <h3>{getCitiesNames(ticket?.fromCity)}</h3>
          </div>
          <div className="ticket-item-city">
            <img src={arrow} alt="arrow" className="destination-arrow" />
          </div>
          <div className="ticket-item-city">
            <h3>{getCitiesNames(ticket?.toCity)}</h3>
          </div>
        </section>
        {getTotalTicketsAmount === 0 && (
          <Alert
            description={`${ticket.ticketName} трябва да пътуват с придружител`}
            type="warning"
            showIcon
            className="ticket-drawer-under-age-alert"
          />
        )}
        <section className="ticket-item-information">
          <div className="ticket-item-information-item-container">
            <div className="box">
              <small>
                {t("departure")} <br /> {getCitiesNames(ticket?.fromCity)} -{" "}
                {getCitiesNames(ticket?.toCity)}
              </small>
              <strong>
                {epochToNormalDate(ticket?.firstDirection?.scheduleStart)}
              </strong>
            </div>
            <div className="box">
              <small>
                {t("departure")} <br /> {getCitiesNames(ticket?.toCity)} -{" "}
                {getCitiesNames(ticket?.fromCity)}
              </small>
              <strong>
                {epochToNormalDate(ticket.secondDirection.scheduleStart)}
              </strong>
            </div>
            <div className="box">
              <small>
                {t("arrival")} <br /> {getCitiesNames(ticket?.fromCity)} -{" "}
                {getCitiesNames(ticket?.toCity)}
              </small>
              <strong>
                {epochToNormalDate(ticket?.firstDirection?.scheduleEnd)}
              </strong>
            </div>

            <div className="box">
              <small>
                {t("arrival")} <br /> {getCitiesNames(ticket?.toCity)} -{" "}
                {getCitiesNames(ticket?.fromCity)}
              </small>
              <strong>
                {epochToNormalDate(ticket.secondDirection.scheduleEnd)}
              </strong>
            </div>
            <div className="box">
              <small>
                {t("place")} <br /> {getCitiesNames(ticket?.fromCity)} -{" "}
                {getCitiesNames(ticket?.toCity)}
              </small>
              <strong>{ticket?.firstDirection?.placeNumber}</strong>
            </div>
            <div className="box">
              <small>
                {t("place")} <br /> {getCitiesNames(ticket?.toCity)} -{" "}
                {getCitiesNames(ticket?.fromCity)}
              </small>
              <strong>{ticket?.secondDirection?.placeNumber}</strong>
            </div>
            <div className="box">
              <small>
                {t("sector")} <br /> {getCitiesNames(ticket?.fromCity)} -{" "}
                {getCitiesNames(ticket?.toCity)}
              </small>
              <strong>{ticket?.secondDirection?.sector}</strong>
            </div>
            <div className="box">
              <small>
                {t("sector")} <br /> {getCitiesNames(ticket?.toCity)} -{" "}
                {getCitiesNames(ticket?.fromCity)}
              </small>
              <strong>{ticket?.firstDirection?.sector}</strong>
            </div>

            <div className="box">
              <small>{t("name")}</small>
              <strong>{ticket.forPerson}</strong>
            </div>

            <div className="box">
              <small>{t("phone")}</small>
              <strong>{ticket.phone}</strong>
            </div>
          </div>
        </section>
        <section className="strap">
          <div className="box">
            <div className="passenger">
              <small>{t("email")}</small>
              <strong>{ticket.email}</strong>
            </div>
            <div className="ticket-card-action-container">
              <div className="date">
                <small>{t("price")}</small>
                <strong>
                  {ticket?.priceTwoWay?.toFixed(2)} €
                </strong>
                {showEuroPrice && (
                  <strong>
                    {convertToEuro(ticket?.priceTwoWay)?.toFixed(2)} {t("lv")}
                  </strong>
                )}
              </div>
              <Button
                onClick={() => {
                  dispatch(
                    cancelTicketReservation(
                      token,
                      companies[0]?.id,
                      localStorageReservedTickets?.find(
                        (item) =>
                          item.kursId === ticket.kursId &&
                          item.placeNumber === ticket.placeNumber
                      )?.firstDirection?.id
                    )
                  );

                  dispatch(
                    cancelTicketReservation(
                      token,
                      companies[0]?.id,
                      localStorageReservedTickets?.find(
                        (item) =>
                          item.kursId === ticket.kursId &&
                          item.placeNumber === ticket.placeNumber
                      )?.secondDirection?.id
                    )
                  );

                  setTimeout(() => {
                    dispatch(
                      getSchedules(
                        token,
                        companies[0]?.id,
                        destinationFrom,
                        destinationTo,
                        dateStringToEpoch(
                          destinationDate.format("DD/MM/YYYY HH:mm")
                        )
                      )
                    );
                  }, 500);

                  setTimeout(() => {
                    dispatch(
                      getSchedulesTwoWay(
                        token,
                        companies[0]?.id,
                        destinationTo,
                        destinationFrom,
                        dateStringToEpoch(
                          destinationDateTwoWay.format("DD/MM/YYYY HH:mm")
                        )
                      )
                    );
                  }, 500);

                  removeTicketFromCart(
                    ticket.firstDirection.kursId,
                    ticket.firstDirection.placeNumber
                  );

                  if (localStorageCart?.length === 1) {
                    localStorage.removeItem("ticketExpirationTime");
                  }
                }}
                className="ticket-item-remove-button"
                danger
              >
                {t("remove")}
              </Button>
            </div>
          </div>
        </section>
      </div>
    </div>
  );
};

export default TicketCardTwoWay;
